import React from 'react';
import '../../App.css';
import hiIcon from '../../assets/icons/hi.svg'; // 在文件顶部引入
import { sendEmailToApp } from '../../utils/nativeBridge';
import { FEATURES } from '../../config';

const Greeting = () => {
  // 处理 "Email Us" 按钮点击事件
  const handleEmailUsClick = () => {
    sendEmailToApp(FEATURES.supportEmail);
  };

  return (
    <div className="chat-widget">
     {FEATURES.showEmailUs &&
     (
      <button onClick={handleEmailUsClick} className="chat-button">
          <img
            src={require('../../assets/icons/email.svg').default}
            alt="Email Icon"
            className="button-icon"
          />
          <span className="button-text">Email Us</span>

          <img
            src={require('../../assets/icons/EmailBig.svg').default}
            alt="Email Icon"
            className="button-icon-2"
          />
      </button>
      )
    }


      <div className="chat-header">
        <img
          src={hiIcon}
          alt="Chat Icon"
          className="chat-icon"
        />
        <div className="chat-header-text">
          <div style={{ fontWeight: '700' }}>Hi there! I'm Elle.</div>
          <div style={{ fontWeight: '700' }}>How can I help you today?</div>
        </div>
      </div>
    </div>
  );
};

export default Greeting;
